import classNames from "classnames";

type Props = {
  showByline?: boolean;
  authorName?: string;
  excerpt?: string;
  showbyLineImage?: boolean;
  darkMode?: boolean;
  highlighted?: string;
  centered?: boolean;
};

const TeaserDownpull = (props: Props) => {
  return (
    <>
      {(props.excerpt || props.showByline) && (
        <p
          className={classNames(
            "mt-2 text-gray-500 text-sm md:text-base",
            props.darkMode ? "text-static-white" : "",
            props.highlighted === "Nivå 1(röd)" ? "text-static-white" : "",
            props.centered ? "text-center" : "",
          )}
        >
          {props.showByline && (
            <span className="font-semibold">
              {props.authorName}
              {props.excerpt && ": "}
            </span>
          )}
          {props.excerpt && <span>{props.excerpt}</span>}
        </p>
      )}
    </>
  );
};

export default TeaserDownpull;
